<script>
	// Stores
	import { 
		linkMapa, 
		linkWaze, 
		linkUber, 
		linkAV, 
		linkAPI, 
		linkWhatsapp,
		linkTelefone,
		tagsSEO, 
		textEndereco, 
		textTelefone, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		textWhatsapp,
		textWhatsappCondominio,
		linkWhatsappCondominio,
		textWhatsappLocacao,
		linkWhatsappLocacao,
		textWhatsappVendas,
		linkWhatsappVendas,
		textWhatsappRH,
		linkWhatsappRH	
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	
	// Code
	let links = [
		{
			title: '2ª Via de Boletos e Extratos',
			link: $linkAV,
			target: '_blank',
		},        
		{
			title: 'Documentação para Alugar',
			link: '/documentacao-necessaria',
		},
		{
			title: 'Anuncie seu Imóvel',
			link: '/anuncie',
		},
		{
			title: 'Solicite um Imóvel',
			link: '/solicite-imovel',
		},
		{
			title: 'Solicite Proposta Condomínio',
			link: '/solicite-proposta',
		},
	];

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber"></i>',
			link: $linkUber,
		}
	];

	let contatos = [
		{
			title: 'Geral <b class="ml-1">' + $textTelefone + '</b>',
			icon: '<i class="fas fa-phone"></i>',
			href: $linkTelefone,
			target: '_blank'
		},
		{
			title: 'Condomínios <b class="ml-1">' + $textWhatsappCondominio + '</b>',
			icon: '<i class="fab fa-whatsapp"></i>',
			href: $linkWhatsappCondominio,
			target: '_blank'
		},
		{
			title: 'Locações <b class="ml-1">' + $textWhatsappLocacao + '</b>',
			icon: '<i class="fab fa-whatsapp"></i>',
			href: $linkWhatsappLocacao,
			target: '_blank'
		},
		{
			title: 'Vendas/Manut. <b class="ml-1">' + $textWhatsappVendas + '</b>',
			icon: '<i class="fab fa-whatsapp"></i>',
			href: $linkWhatsappVendas,
			target: '_blank'
		}
	];    
</script>

<footer class="mt-20">
	<section class="footer-banner">
		<div class="container">
			<div class="footer-banner__box">
				{#each contatos as contato}
					<a class="footer-banner__item" href="{contato.href}" title="Contato via {contato.title} - {$textSite}" target="_blank">
						{@html contato.icon} {@html contato.title}
					</a>
				{/each}
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="itens text-center">
				<div class="item text-lg-left col-12 col-lg-3 pr-0">
					<div class="mb-20">
						<a href="/"><img src="/assets/images/logoWhite.png" alt="{$textSite}" /></a>
					</div>
					<p class="line-height-large">{$tagsSEO}</p>
				</div>
				<div class="item col-12 col-lg-3">
					<h3 class="subtitle"><i class="fas fa-clock"></i> <b>Horário</b></h3>
					<ul>
						<li>
							<p>{@html $textAtendimento}</p>
						</li>
					</ul>
				</div>
				<div class="item col-12 col-lg-3">
					<h3 class="subtitle"><i class="fas fa-map-marker-alt"></i> <b>Endereço</b></h3>
					<ul>
						<li><p class="mb-0">{@html $textEndereco}</p></li>
						<ul class="list list--point">
							{#each localizacao as item}
							<li class="list-item">
								<a href="{item.link}" title="Endereço {$textSite} via {item.title}" target="_blank">
									{@html item.icon != null ? item.icon : ""} {item.title}
								</a>
							</li>
							{/each}
						</ul>
					</ul>        
				</div>
				<div class="item d-none d-lg-block text-lg-right col-12 col-lg-3">
					<h3 class="subtitle"><b>Acesso Rápido</b></h3>
					<ul>
						{#each links as item}
						<li>
							<a href="{item.link}" use:link replace title="Ir para {item.title}" target="{item.target}">
								{@html item.icon != null ? item.icon : ""} {item.title}
							</a>
						</li>
						{/each}
					</ul>
					<div class="mt-20">
						<img src="/assets/images/SecoviAgademi.png" alt="Empresa associada Secovi RS, Agademi" />					
					</div>
				</div>
			</div>
			<p class="copyright mt-30"><a href="/politica-de-privacidade" target="_blank">Política de Privacidade</a></p>
			<p class="copyright">© Copyright 2021 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os Direitos Reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></p>
		</div>
	</section>
</footer>